// external dependencies
import React from 'react';
import Grid from '@material-ui/core/Grid';

const EnhancedGrid = ({ children, ...other }) => {
  return (
    <Grid container {...other}>
      {children}
    </Grid>
  );
};

export default EnhancedGrid;
